import { GlButton, GlSprintf } from '@gitlab/ui';
export default {
    name: 'VerificationRecoverAccount',
    components: {
        GlButton,
        GlSprintf
    },
    emits: [
        'recover'
    ]
};
